export default __webpack_public_path__ + "static/media/Notification.bc52cd98.svg";